/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// This file is generated by scripts/update-specs.js
export { default as basename } from './completions/upstream/basename';
export { default as cat } from './completions/upstream/cat';
export { default as chmod } from './completions/upstream/chmod';
export { default as chown } from './completions/upstream/chown';
export { default as clear } from './completions/upstream/clear';
export { default as cp } from './completions/upstream/cp';
export { default as curl } from './completions/upstream/curl';
export { default as cut } from './completions/upstream/cut';
export { default as date } from './completions/upstream/date';
export { default as dd } from './completions/upstream/dd';
export { default as df } from './completions/upstream/df';
export { default as diff } from './completions/upstream/diff';
export { default as dig } from './completions/upstream/dig';
export { default as dirname } from './completions/upstream/dirname';
export { default as du } from './completions/upstream/du';
export { default as echo } from './completions/upstream/echo';
export { default as env } from './completions/upstream/env';
export { default as export } from './completions/upstream/export';
export { default as fdisk } from './completions/upstream/fdisk';
export { default as find } from './completions/upstream/find';
export { default as fmt } from './completions/upstream/fmt';
export { default as fold } from './completions/upstream/fold';
export { default as grep } from './completions/upstream/grep';
export { default as head } from './completions/upstream/head';
export { default as htop } from './completions/upstream/htop';
export { default as id } from './completions/upstream/id';
export { default as jq } from './completions/upstream/jq';
export { default as kill } from './completions/upstream/kill';
export { default as killall } from './completions/upstream/killall';
export { default as less } from './completions/upstream/less';
export { default as ln } from './completions/upstream/ln';
export { default as ls } from './completions/upstream/ls';
export { default as lsblk } from './completions/upstream/lsblk';
export { default as lsof } from './completions/upstream/lsof';
export { default as mkdir } from './completions/upstream/mkdir';
export { default as more } from './completions/upstream/more';
export { default as mount } from './completions/upstream/mount';
export { default as mv } from './completions/upstream/mv';
export { default as nl } from './completions/upstream/nl';
export { default as od } from './completions/upstream/od';
export { default as paste } from './completions/upstream/paste';
export { default as ping } from './completions/upstream/ping';
export { default as pkill } from './completions/upstream/pkill';
export { default as ps } from './completions/upstream/ps';
export { default as pwd } from './completions/upstream/pwd';
export { default as readlink } from './completions/upstream/readlink';
export { default as rm } from './completions/upstream/rm';
export { default as rmdir } from './completions/upstream/rmdir';
export { default as rsync } from './completions/upstream/rsync';
export { default as scp } from './completions/upstream/scp';
export { default as sed } from './completions/upstream/sed';
export { default as seq } from './completions/upstream/seq';
export { default as shred } from './completions/upstream/shred';
export { default as sort } from './completions/upstream/sort';
export { default as source } from './completions/upstream/source';
export { default as split } from './completions/upstream/split';
export { default as stat } from './completions/upstream/stat';
export { default as su } from './completions/upstream/su';
export { default as sudo } from './completions/upstream/sudo';
export { default as tac } from './completions/upstream/tac';
export { default as tail } from './completions/upstream/tail';
export { default as tar } from './completions/upstream/tar';
export { default as tee } from './completions/upstream/tee';
export { default as time } from './completions/upstream/time';
export { default as top } from './completions/upstream/top';
export { default as touch } from './completions/upstream/touch';
export { default as tr } from './completions/upstream/tr';
export { default as traceroute } from './completions/upstream/traceroute';
export { default as tree } from './completions/upstream/tree';
export { default as truncate } from './completions/upstream/truncate';
export { default as uname } from './completions/upstream/uname';
export { default as uniq } from './completions/upstream/uniq';
export { default as unzip } from './completions/upstream/unzip';
export { default as wc } from './completions/upstream/wc';
export { default as wget } from './completions/upstream/wget';
export { default as where } from './completions/upstream/where';
export { default as whereis } from './completions/upstream/whereis';
export { default as which } from './completions/upstream/which';
export { default as who } from './completions/upstream/who';
export { default as xargs } from './completions/upstream/xargs';
export { default as xxd } from './completions/upstream/xxd';
export { default as zip } from './completions/upstream/zip';
export { default as apt } from './completions/upstream/apt';
export { default as brew } from './completions/upstream/brew';
export { default as nano } from './completions/upstream/nano';
export { default as vim } from './completions/upstream/vim';
export { default as ssh } from './completions/upstream/ssh';
export { default as adb } from './completions/upstream/adb';
export { default as docker } from './completions/upstream/docker';
export { default as dockerCompose } from './completions/upstream/docker-compose';
export { default as dotnet } from './completions/upstream/dotnet';
export { default as go } from './completions/upstream/go';
export { default as node } from './completions/upstream/node';
export { default as nvm } from './completions/upstream/nvm';
export { default as yo } from './completions/upstream/yo';
export { default as python } from './completions/upstream/python';
export { default as python3 } from './completions/upstream/python3';
export { default as ruff } from './completions/upstream/ruff';
export { default as bundle } from './completions/upstream/bundle';
export { default as ruby } from './completions/upstream/ruby';
